import React from 'react'
import { tagAxisIds } from '@cpsy-rmap-project/tags'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import _ from 'lodash'
import Pill from '../../atoms/Pill'
import { usePaperDetailsModal } from '../../molecules/PaperDetailsModal/hooks'
import { usePaper } from '../../organisms/Paper'

export const RecentlyList = () => {
  const { papers } = usePaper()
  const { handlePaperDetailsModalOpen } = usePaperDetailsModal()
  const recentlyPapers = _.orderBy(papers, ['createdAt.seconds'], ['desc']).slice(0, 25)
  return (
    <List>
      {recentlyPapers.map(paper => (
        <ListItem button key={paper.id} onClick={() => {}} divider>
          <ListItemText
            onClick={() => {
              handlePaperDetailsModalOpen(paper)
            }}
            primary={
              <>
                {_.truncate(paper.title, {
                  length: 150 /* 最大150字 */
                })}
              </>
            }
            secondary={
              <>
                <Typography component="span" variant="body2" color="textPrimary">
                  {_.truncate(paper.authors, {
                    length: 100 /* 最大100字 */
                  })}
                  , {paper.year}
                </Typography>
                {!_.isEmpty(paper.journal) && (
                  <>
                    <br />
                    {paper.journal}
                  </>
                )}
                {/* <br />
                  Citation: {paper.citedCount} */}
                <br />
                {tagAxisIds.map(
                  tagAxisId =>
                    paper[tagAxisId].length > 0 && <Pill key={tagAxisId} id={paper[tagAxisId][0]} isInlineBlock />
                )}
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  )
}
